import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Lang = 'no' | 'en';

interface LangState {
  lang: Lang;
  setLang: (lang: Lang) => void;
}

export const useLangStore = create<LangState>()(
  persist(
    (set) => ({
      lang: 'no',
      setLang: (lang) => set({ lang }),
    }),
    { name: 'goodatoms-lang' },
  ),
);
